import datum from '../datum.model';
import { DatumModel } from '../datum.model';

export interface TreeModel {
  [key: string]: DatumModel;
}

export interface Record {
  [key: string]: any;
}

/**
 * Straight Tree
 *
 * @todo optimize for performance and garbage collection
 * @param records
 * @param cols
 * @param value - option
 * @param formatter - option
 * @param rowLimit - option
 * @param memoize - option
 * @returns {TreeModel}
 */
const straightTree = function (
  records,
  cols,
  { value = null, formatter = null, rowLimit = records.length, memoize = false }
) {
  value = typeof value === 'function' ? value : defaultValue;
  formatter = typeof formatter === 'function' ? formatter : defaultFormatter;
  return records.slice(0, rowLimit).reduce(treeReducer({ value, formatter, cols, memoize }), {});
};

function treeReducer({
  value,
  formatter,
  cols,
  memoize,
}: {
  value: any;
  formatter: any;
  cols: Array<string>;
  memoize: boolean;
}) {
  return function appendTreeMember(tree: TreeModel, record: Record, rowKey: string | number) {
    tree[String(rowKey)] = cols.reduce(treeMemberReducer({ value, formatter, record, memoize }), {});
    return tree;
  };
}

function treeMemberReducer({ value, formatter, record, memoize }) {
  return function recordToDatumModel(row, colKey) {
    const data = record[colKey];
    const itemValue = value(data, colKey);
    const itemFormatter = formatter(itemValue(), colKey);
    row[colKey] = datum(data, itemValue, itemFormatter, memoize);
    return row;
  };
}

function defaultValue(axelData, _) {
  return function value() {
    return axelData;
  };
}

function defaultFormatter(axelData, _) {
  return function formatter() {
    return axelData.valueOf();
  };
}

export { straightTree };
